import { useCallback } from "react";
import { Magazine } from "./Datatypes";
import { getInfo } from "./FetchFromAPI";
import { usePersistBoundStore } from "./zustand/Store";

export const useFetchLiveMagazines = () => {
    return async (): Promise<Magazine[]> => {
        let magazines: Magazine[] = [];
        const fetchMagazines = await getInfo();
        JSON.parse(fetchMagazines).map((e: any) => {
            const newMagazine: Magazine = {
                date: e.publicationDate,
                edition: e.edition,
                pageFiles: e.pageInfo.map((p: any) => {
                    return {
                    page: p.pageNumber,
                    pageStatus: p.pageStatus,
                    ressort: p.ressort,
                    downloaded: false,
                    filesize: 0,
                    }
                }),
                //numberOfPages: e.numberOfPages,
            }
            //console.log(JSON.stringify(newMagazine, null, 2));
            magazines.push(newMagazine)
        });
        magazines.sort((a, b) => b.date.localeCompare(a.date));
        //console.log("useFetchLiveMagazines - am ", magazines);
        return magazines;
    }
};

export const useFetchArchiveMagazines = () => {
    const getAllStoredEpapers = usePersistBoundStore(
        useCallback((state) => state.getAllStoredEpapers, [])
    );

    return (): Magazine[] => {
        const storedMagazines = getAllStoredEpapers();
        storedMagazines.sort((a, b) => b.date.localeCompare(a.date));
        //console.log("useFetchArchiveMagazines - magazines ", storedMagazines);
        return storedMagazines;
    };
};